import React, { useState,  useRef } from "react";
import { connect } from "react-redux";
import axios from "../../axios-vmou";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import styles from "./billstat.module.css";
import Navbar from "../main/navbar";
import logo from "../../assets/vmou.png";
import { Sidebar } from 'primereact/sidebar';
import * as actions from '../../store/actions/index'
import { useHistory } from "react-router-dom";

const Billstat = (props) => {
  const [visibleRight, setVisibleRight] = useState(false);
  const onSignout = () => {
    props.onlogout();
  }
  const exams = [
    "JUNE22",
    "DEC22",
    "JUNE23"
  ]

  const [bills, setbills] = useState([]);
  const [selectedExam, setSelectedExam ] = useState('JUNE23');
  const [selectedBills, setSelectedBills] = useState(null);
  const [globalFilter, setGlobalFilter] = useState(null);
  const toast = useRef(null);
  const dt = useRef(null);
  const history = useHistory()
  
  const billsearch = (event) => {
    event.preventDefault();  
    billsearchmodule();
  }

  const billsearchmodule = () => {
    let authOptions = {
      method: 'PUT',
      url: '/bill/ByCoord/', 
      data: {'userid':props.userid,'exam':selectedExam},
      headers : {
          'x-auth-token' : localStorage.getItem('token')
      }
    };
    axios(authOptions)
    .then(response => {
      setbills(response.data);
    })
    .catch(error => {
      toast.current.show({severity: 'error', summary: 'Error Message', detail: error.response.data});
    });
  }

  const Statement = () => {
    history.push({
      pathname: '/Statement',
      state: {bills:bills}
  });
};


  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const printBill = (bill) => {
    history.push({
      pathname: '/BillPrint',
      state: {bill:bill}
  });
};


  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-print"
          className="p-button-rounded p-button-text p-button-success p-mr-2"
          onClick={() => printBill(rowData)}
        />
      </React.Fragment>
    );
  };

  const header = (
    <div className={styles.tableheader}>
      <Button
          label="Export"
          icon="pi pi-upload"
          className="p-button-help"
          onClick={exportCSV}
        />
        <Button
          label="Print"
          icon="pi pi-print"
          className="p-button-warning"
          onClick={() => Statement()}
        />
        <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
        />
      </span>
    </div>
  );
  const formatDate = (dt) => {
    let cdt = new Date(dt);
    let month = cdt.getMonth() + 1;
    let day = cdt.getDate();
    if (month < 10) {
        month = '0' + month;
    }
    if (day < 10) {
        day = '0' + day;
    }
    return (dt)?day+"-"+month+"-"+cdt.getFullYear():'' ;
  };


  const dateBodyTemplate = (rowData) => formatDate(rowData.billdate);
  const grossBodyTemplate = (rowData) => rowData.gross.toFixed(2);
  const swfBodyTemplate = (rowData) => rowData.swf.toFixed(2);
  const tdsBodyTemplate = (rowData) => rowData.tds.toFixed(2);
  const netBodyTemplate = (rowData) => rowData.netamt.toFixed(2);
  return (
    <div className={styles.datatablecruddemo}>
      <Toast ref={toast} />
      <Sidebar className="flex align-items-center " visible={visibleRight} position="right" onHide={() => setVisibleRight(false)}>
          <h2>User Profile....</h2>
          <h5>Coord ID : {props.email}</h5>
          <h5>Name        : {props.username}</h5>
          <Button className="p-button-text p-button-danger ml-4" style={{}} onClick={onSignout}>Sign Out</Button>
        </Sidebar>
      <div className="Headerusr" style={{ position: "sticky" }}>
        <img
          src={logo}
          alt="VMOU"
          height={100}
          width={90}
          style={{ margin: "0px 0 0 20px" }}
        ></img>
        <h2 style={{ marginTop: "0", textAlign: "center" }}>
          Coordinator Module
          <br />
          Bill Statement
        </h2>
        <div className="Userusr" onClick={(e) => setVisibleRight(true)}>
          <i style={{'fontSize': '1.5em'}} className="pi pi-user mr-6 mt-2 text-right"></i>
          <h4 style={{margin:'0 30px 0 0',textAlign:'end'}} >Hi, {props.username}</h4>
        </div>
      </div>
      <Navbar />
      <div className={styles.Sformpr}>
            <div className=" ">
                <label htmlFor="centre" className="">Select Exam</label>
                <Dropdown className="ml-4 my-1 h-auto" value={selectedExam} options={exams} onChange={(e) => setSelectedExam(e.value)}  placeholder="Select Exam" />
            </div>
            <Button icon="pi pi-search" className="ml-4 p-button-text p-button-success" onClick={billsearch}/>
      </div>
      <div className={styles.card}>
        <DataTable
          resizableColumns
          columnResizeMode="fit"
          showGridlines
          className="p-datatable-sm"
          ref={dt}
          value={bills}
          selection={selectedBills}
          onSelectionChange={(e) => setSelectedBills(e.value)}
          dataKey="billno"
          sortField="billno"
          sortOrder={1}
          paginator
          rows={10}
          rowsPerPageOptions={[5, 10, 25]}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} examiners"
          globalFilter={globalFilter}
          header={header}
          responsiveLayout="scroll"
        >
          <Column
            field="billno"
            header="Bill No"
            sortable
            style={{ width: "13%" , textAlign:"center",padding:'0 1px 0 4px' }}
          ></Column>
          <Column
            field="billdate"
            header="Date"
            sortable
            body={dateBodyTemplate}
            style={{ width: "18%"  ,textAlign:"center",padding:'0 1px 0 1px'}}
          ></Column>
          <Column 
            field="examinerid.name" 
            header="Examiner" 
            style={{ width: "20%" , padding:'0 1px 0 1px' }}
          ></Column>
          <Column
            field="gross"
            header="Gross"
            body={grossBodyTemplate}
            style={{ width: "10%" ,textAlign:"right", padding:'0 1px 0 1px' }}
          ></Column>
          <Column
            field="swf"
            header="S.W.F."
            body={swfBodyTemplate}
            style={{ width: "10%" , textAlign:"right", padding:'0 1px 0 1px' }}
          ></Column>
          <Column
            field="tds"
            header="T.D.S."
            body={tdsBodyTemplate}
            style={{ width: "10%" , textAlign:"right", padding:'0 1px 0 1px' }}
          ></Column>
          <Column
            field="netamt"
            header="Net Amt"
            body={netBodyTemplate}
            style={{ width: "8%"  , textAlign:"right", padding:'0 1px 0 1px'}}
          ></Column>
          <Column
            body={actionBodyTemplate}
            exportable={false}
            style={{ textAlign:"center",  padding:'0 1px 0 1px'}}
          ></Column>
        </DataTable>
      </div>


    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    username: state.auth.username,
    userid: state.auth.userid,
    email: state.auth.email,
    isAuth: state.auth.token !== null,
  };
};

const mapDispatchToProps = dispatch => {
  return {
      onlogout:() => dispatch(actions.logout())
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Billstat);